import * as queryString from 'query-string'
import * as raf from 'raf'

import { Site } from '@envato/foundation-types'

import { logPageview } from '../utils/eventsApi'
import ga from '../utils/ga'
import { getPageTypeFromURL } from '../utils/location/getPageTypeFromUrl'
import { ILocationParams } from '../utils/location/types'
import { trackPageViewFor } from '../utils/tracking/trackPageViewCount'

export const reportPageView = () => {
  if (typeof document === 'undefined') {
    return
  }
  ga('send', {
    hitType: 'pageview',
    title: document.title
  })
  ga('set', {
    referrer: null
  })
}

// @see https://github.com/envato/market-shopfront/pull/2258
export const rafReportPageView = () => raf(reportPageView)

export const reportRouteChange = () => {
  const dataLayer = (window as any).dataLayer as [Record<string, unknown>]
  dataLayer.push({
    event: 'routeChange'
  })
}

export const reportPageType = (pageType: string, currentSite?: Site) => {
  const newrelic = (window as any).newrelic
  if (newrelic) {
    newrelic.interaction().setAttribute('pageType', pageType)
  }
  ga('set', 'dimension20', pageType)

  if (currentSite) {
    trackPageViewFor(currentSite, pageType)
  }
}

export const reportSearchPageType = (
  locationParams: ILocationParams,
  currentSite: Site
) => {
  if (locationParams.category && !locationParams.tags && !locationParams.term) {
    reportPageType('category', currentSite)
  } else {
    reportPageType('search', currentSite)
  }
}

export const reportPerformanceMetrics = (metrics: any) => {
  const newrelic = (window as any).newrelic
  const pageType = getPageTypeFromURL(window.location)
  const params = queryString.parse(window.location.search)
  const nextMetrics = {
    ...metrics,
    pageType
  }

  if (newrelic) {
    newrelic.addPageAction('performanceMeasurement', nextMetrics)
  }

  logPageview({
    currentSite: window.location.hostname,
    pathname: window.location.pathname,
    metrics: nextMetrics,
    pageType,
    params
  })
}
